import { render, staticRenderFns } from "./video-calibration-page.vue?vue&type=template&id=9d8a4eac&scoped=true"
import script from "./video-calibration-page.vue?vue&type=script&lang=js"
export * from "./video-calibration-page.vue?vue&type=script&lang=js"
import style0 from "./video-calibration-page.vue?vue&type=style&index=0&id=9d8a4eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8a4eac",
  null
  
)

export default component.exports